<div class="timeline-container">
    <div class="year-container">
        <div *ngFor="let year of getYears(); index as i"
             [class]="{'year-container-year-active': activeYear == i}"
             class="year-container-year"
             (click)="select(i, 'year')"
        >
            <div class="year-container-year-hatch"></div>
            <div class="year-container-year-label">
                {{ year }}
            </div>
        </div>
    </div>
    <div *ngIf="!disableMonth" class="months-container">
        <div *ngFor="let month of getMonths(); index as i"
             class="months-container-month"
             [class]="{'months-container-month-active': activeMonth == i,
             'months-container-month-last' : getMonths().length - 1 == i,
              'months-container-month-none' : !getPermitted(i)}"
             (click)="select(i, 'month')"
        >{{ month }}
        </div>
    </div>
    <div (click)="left()" class="arrows arrows-left">
        <app-icon [icon]="Icons.arrow2"/>
    </div>
    <div (click)="right()" class="arrows arrows-right">
        <app-icon [icon]="Icons.arrow2"/>
    </div>
</div>
